import React, { PureComponent, Fragment } from 'react';
import {
  /*isMobilePhone*/
} from '../../../library/calc';
import {
  imageBasePath,
} from '../../../library/constants';


class MenuBar extends PureComponent {

  onClick({nodeObj, flipNodeCrumb}){

    if( typeof(window.forceHideMoreList) !== 'undefined' ) window.forceHideMoreList();

    if( this.props.isPedigree ) {
      this.props.setPedigreeAddbox({visible: false});
    }

    this.props.clickforImmediateFamily({
      nodeObj,
      doWhatToFlipNodeCrumbs: 'remove',
    })

    this.props.flippanelShouldUpdate({once: true});
  }

  componentDidUpdate(){

    // console.log(`flipNodeCrumbs: `, JSON.stringify(this.props.flipNodeCrumbs, null, 2));
  }

  render () {

    const menuBarStyle = {
      height: `40px`,
      background: 'lightgray',
      cursor: 'pointer'
    }

    const closeStyle = {
      marginTop: '3px',
      cursor:'pointer',
      float: 'right',
      width: '34px',
    }

    const flipNodeCrumbStyle = {
      marginTop: '12px',
      cursor:'pointer',
      float: 'left',
      width: '300px',
      color: 'grey'
    }

    const {
      toggleFlipPanel,
      flipNodeCrumbs,
      nodeObjs,
    } = this.props;

    const flipNodeCrumb = flipNodeCrumbs[(flipNodeCrumbs.length - 2)];
    let fullName = (
      typeof(flipNodeCrumb) !== 'undefined' &&
      typeof(nodeObjs[flipNodeCrumb]) !== 'undefined'
      ? nodeObjs[flipNodeCrumb].nm: '');

    // fullName = shrinkWordsWidth({word: fullName, maxLength: 60});

    return (
        <div
          style={menuBarStyle}
        >

          {

                flipNodeCrumbs.length > 1

            ?
                <Fragment>
                  <img
                    alt=""
                    onClick={()=>{
                      this.onClick({nodeObj:nodeObjs[flipNodeCrumb], flipNodeCrumb});
                    }}
                    src={imageBasePath + '_ionicons_svg_md-arrow-back.svg'}
                    style={{
                      ...closeStyle,
                      marginTop: '8px',
                      marginRight: '3px',
                      width: '24px',
                      float: 'left',
                      opacity: '.3'
                    }} />
                  <div
                    style={flipNodeCrumbStyle}
                    onClick={()=>{
                      this.onClick({nodeObj: nodeObjs[flipNodeCrumb], flipNodeCrumb});
                    }}
                  >
                    { fullName }
                  </div>
                </Fragment>
            :

                null


          }
          <img
              alt=""
              onClick={()=>{
                toggleFlipPanel({close: true, from: 'desktop flip menu'});
              }}
              src={imageBasePath + 'ic_keyboard_arrow_left_black_24px.svg'}
              style={closeStyle} />
        </div>
    )
  }
}

export default MenuBar;
